import { jsxs as i, jsx as a } from "react/jsx-runtime";
import "react";
import '../../assets/AnchorTag.css';const s = {
  "anchor-tag--image": "_anchor-tag--image_1nb7n_1"
};
function g({ href: e = "", classname: t = "", label: l = "", type: n = "internal-link", image: r = null }) {
  return r !== null ? /* @__PURE__ */ i(
    "a",
    {
      href: e,
      className: [t, s["anchor-tag--image"], "anchor-tag--image"].join(" "),
      rel: n === "external-link" ? "noreferrer" : null,
      target: n === "internal-link" ? "_self" : "_blank",
      style: {
        "--anchor-tag-image-ratio": r.width / r.height
      },
      children: [
        /* @__PURE__ */ a("img", { src: r.url, alt: l }),
        /* @__PURE__ */ a("span", { className: "sr-only", children: l })
      ]
    }
  ) : /* @__PURE__ */ a(
    "a",
    {
      href: e,
      className: t,
      rel: n === "external-link" ? "noreferrer" : null,
      target: n === "internal-link" ? "_self" : "_blank",
      children: l
    }
  );
}
export {
  g as AnchorTag,
  g as default
};
